import { render, staticRenderFns } from "./AdditionalQuestion.vue?vue&type=template&id=98feacf4&scoped=true"
import script from "./AdditionalQuestion.vue?vue&type=script&lang=js"
export * from "./AdditionalQuestion.vue?vue&type=script&lang=js"
import style0 from "./AdditionalQuestion.vue?vue&type=style&index=0&id=98feacf4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98feacf4",
  null
  
)

export default component.exports